import React from "react";
import {connect} from "react-redux";
import {useHistory} from "react-router-dom";

import GoodsCategory from "./partials/goods-category/GoodsCategory";
import SearchGoodsCategory from "./partials/search-goods-category/SearchGoodsCategory";
import NewsCategory from "./partials/news-category/NewsCategory";
import Search from "./partials/search/Search";
import Cart from "./partials/cart/Cart";
import Nav from "./partials/nav/Nav";

import Router from "router/router";
import CategoryType from "enum/CategoryType";
import * as css from "./css/menu";
import {inject, observer} from "mobx-react";
import {logo, logoStyle} from "api/commonApi";

function Menu(props) {
    const {app, className, menu} = props;
    const {categoryType} = app;
    const history = useHistory();

    function renderCategory() {
        switch (categoryType) {
            case CategoryType.NONE.value:
                return null;
            case CategoryType.NEWS_CATEGORY.value:
                return <css.Category as={NewsCategory}/>;
            case CategoryType.SEARCH_GOODS_CATEGORY.value:
                return <css.Category as={SearchGoodsCategory}/>;
            case CategoryType.GOODS_CATEGORY.value:
            default:
                return <css.Category as={GoodsCategory}/>;
        }
    }

    return (
        <css.Menu className={className}>
            {/* bg */}
            <div className="bg-img-wrapper">
                <img src={require("./img/bg.png")} alt="" className="bg-img"/>
            </div>
            {/* container */}
            <css.Container is1200={menu.is1200}>
                <css.TopWrapper>
                    {/* logo */}
                    <img
                        src={logo}
                        style={{
                            ...logoStyle,
                            cursor: 'pointer'
                        }}
                        onClick={() => {
                            history.replace(Router.Home.path);
                        }}
                    />
                    {/* 搜索 */}
                    <css.Search as={Search}>
                        <css.Cart as={Cart}/>
                    </css.Search>
                </css.TopWrapper>
                {/* nav */}
                <css.Nav as={Nav}/>
                <css.MerchantImg
                    src={require("./img/merchant-img.png")}
                    onClick={() => {
                        window.open(`${Router.basename}${Router.Merchant.path}`);
                    }}
                />
                {/* category */}
                {renderCategory()}
            </css.Container>
        </css.Menu>
    );
}

export default connect(
    (state) => {
        const {app} = state;

        return {app};
    },
    (f) => ({

    })
)(inject("menu")(observer(Menu)));
